import {DetailDialog, DetailDialogProps} from "../../../../components/DetailDialog";
import {EQUIPMENT_URLS, URL_PARAMS, DISP_MODE} from "../../../../constants/constants";

export interface FingertipDetailDialogProps extends Omit<DetailDialogProps, 'title' | 'src'> {
  fingertipId: string,
}

export function FingertipDetailDialog(props: FingertipDetailDialogProps) {
  // console.log('Hand Detail Dialog', props.handId);
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <DetailDialog {...props} title='爪詳細' src={`${EQUIPMENT_URLS.FINGERTIP_DETAIL.URL}/${props.fingertipId}?${URL_PARAMS.DISP_MODE}=${DISP_MODE.POPUP}`}/>
  )
}
